import {
  Box,
  Container,
  Typography,
  Paper,
  LinearProgress,
  Avatar,
  useTheme,
  useMediaQuery,
  Stack,
  styled,
} from "@mui/material";
import React from "react";
import { palette, theme as colorTheme } from "../../../Convoze.theme";


const primary = colorTheme('palette', 'primary').value;
const positive = colorTheme('palette', 'positive').value;
const neutral = colorTheme('palette', 'neutral').value;
const negative = colorTheme('palette', 'negative').value;



const DashboardCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: 12,
  border: "1px solid #e0e0e0",
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
    margin: theme.spacing(0, 1, 2, 1),
  },
}));

const StyledLinearProgress = styled(LinearProgress)(
  ({ theme, progresscolor }) => ({
    height: 8,
    borderRadius: 4,
    backgroundColor: "#f0f0f0",
    "& .MuiLinearProgress-bar": {
      borderRadius: 4,
      backgroundColor: progresscolor || primary,
    },
    [theme.breakpoints.down("sm")]: {
      height: 6,
    },
  })
);



const StreakBadge = styled(Avatar)(({ theme }) => ({
  backgroundColor: primary,
  color: "white",
  width: 48,
  height: 48,
  fontSize: "1.25rem",
  fontWeight: "bold",
  [theme.breakpoints.down("sm")]: {
    width: 40,
    height: 40,
    fontSize: "1rem",
  },
}));

function WeeklyProgressBar() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const weeklyData = {
    thisWeek: { completed: 22, total: 30 },
    lastWeek: { completed: 26, total: 30 },
    currentStreak: 14,
  };

  const thisWeekPercentage =
    (weeklyData.thisWeek.completed / weeklyData.thisWeek.total) * 100;
  const lastWeekPercentage =
    (weeklyData.lastWeek.completed / weeklyData.lastWeek.total) * 100;
  return (
    <>
      {/* Weekly Progress Card */}
      <Paper
        elevation={0}
        sx={{
          flex: 1,
          p: 2,
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          //   justifyContent: "space-between",
          // gap: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 5,
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 1 : 0,
          }}
        >
          <Typography
            variant={isMobile ? "h6" : "h6"}
            component="h1"
            fontWeight="600"
            color="text.primary"
            sx={{ textAlign: isMobile ? "center" : "left" }}
          >
            Weekly Progress
          </Typography>
        </Box>

        {/* This Week Progress */}
        <Box sx={{ mb: 3 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
            }}
          >
            <Typography variant="body1" fontWeight="500" color="text.secondary">
              This Week
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <span style={{ color: primary, fontWeight: 600 }}>
                {weeklyData?.thisWeek?.completed}/{weeklyData?.thisWeek.total}
              </span>{" "}
              tasks
            </Typography>
          </Box>
          <StyledLinearProgress
            variant="determinate"
            value={thisWeekPercentage}
            progresscolor={primary}
          />
        </Box>

        {/* Last Week Progress */}
        <Box sx={{ mb: 3 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
            }}
          >
            <Typography variant="body1" fontWeight="500" color="text.secondary">
              Last Week
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <span style={{ color: primary, fontWeight: 600 }}>
                {weeklyData?.lastWeek?.completed}/{weeklyData?.lastWeek.total}
              </span>{" "}
              tasks
            </Typography>
          </Box>
          <StyledLinearProgress
            variant="determinate"
            value={lastWeekPercentage}
            progresscolor="#9e9e9e"
          />
        </Box>

        {/* Current Streak */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pt: 2,
            borderTop: "1px solid #f0f0f0",
          }}
        >
          <Box>
            <Typography variant="body1" fontWeight="600" color="text.primary">
              Current Streak
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Keep it up for rewards!
            </Typography>
          </Box>
          <StreakBadge>{weeklyData?.currentStreak}</StreakBadge>
        </Box>

       
      </Paper>
    </>
  );
}

export default WeeklyProgressBar;
